export default "__VITE_ASSET__tQxWy1lC__"